import React, { useEffect, useContext,useMemo } from 'react';
import { Form } from "antd";
import { Settings } from './Settings';

import { Resizer,FormContext } from 'wsc-react-custom-form';
import ConditionList from './ConditionList';

const defaultProps = {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    fillSpace: 'no',
    padding: ['0', '0', '0', '0'],
    margin: ['0', '0', '0', '0'],
    background: { r: 255, g: 255, b: 255, a: 1 },
    color: { r: 0, g: 0, b: 0, a: 1 },
    shadow: 0,
    radius: 0,
    width: '100%',
    height: 'auto',
};

export const FormNodeSwitch = (props) => {
    props = {
        ...defaultProps,
        ...props,
    };
    const {
        flexDirection,
        alignItems,
        justifyContent,
        fillSpace,
        background,
        color,
        padding,
        margin,
        shadow,
        radius,
        label,
        labelSpan,
        labelOffset,
        wrapperSpan,
        wrapperOffset,
        showLabel,
        name,
        rules,
        multiple,
        disabled,
    } = props;

    const { form, formdata } = useContext(FormContext);

    const _props = Form.useWatch(name, form);
    // 监听表单值变化
    useEffect(() => {
        // 根据 name 的值更新 anotherField
        const newValue = _props?.conditions.length;
        form.setFieldValue('outputs', newValue);
    }, [_props]);

        // name使用点号分割的：转换为数组
    const nameArray = useMemo(()=>{
        const names = name.split('.');
        if (names.length === 1) {
        return names[0];
        } else {
        return names;
        }
    }, [name]);

    useEffect(() => {
        //表单值发生变化，反应到组件中
        form.setFieldValue(name, formdata[name]);
    }, [formdata[name]]);


      // 获取级联属性
  useEffect(()=> {
    if (Array.isArray(nameArray)) {
      const value = nameArray.reduce((acc, item) => {
        if (acc?.hasOwnProperty(item)) {
          return acc[item];
        }
        return undefined;
      }, formdata);
      form.setFieldValue(nameArray, value);
    } else {
      form.setFieldValue(nameArray, formdata[name]);
    }
  }, [form, formdata, nameArray]);

    let noLabel = (showLabel == "false");
    return (<Resizer
        propKey={{ width: 'width', height: 'height' }}
        style={{
            justifyContent,
            flexDirection,
            alignItems,
            background: `rgba(${background.r},${background.g},${background.b},${background.a})`,
            color: `rgba(${color.r},${color.g},${color.b},${color.a})`,
            padding: `${padding[0]}px ${padding[1]}px ${padding[2]}px ${padding[3]}px`,
            margin: `${margin[0]}px ${margin[1]}px ${margin[2]}px ${margin[3]}px`,
            boxShadow:
                shadow === 0
                    ? 'none'
                    : `0px 3px 100px ${shadow}px rgba(0, 0, 0, 0.13)`,
            borderRadius: `${radius}px`,
            flex: fillSpace === 'yes' ? 1 : 'unset',
        }}
    ><Form.Item
        style={{ width: "100%" }}
        label={noLabel?null:label}
        labelCol={{span: labelSpan, offset: labelOffset}}
        wrapperCol={{span: wrapperSpan, offset: wrapperOffset}}
        name={nameArray}
        rules={rules}
    >
        <ConditionList />
    </Form.Item></Resizer>);
};


FormNodeSwitch.craft = {
    displayName: 'FormNodeSwitch',
    props: {
        name: "props",
        label: "条件",
        labelSpan: 6,
        labelOffset: 0,
        wrapperSpan: 18,
        wrapperOffset: 0,
        showLabel: "true",
        multiple: "false",
        disabled: "false",
        rules: [{ required: true, message: "lua脚本必须填写！" }],
        ...defaultProps
    },
    related: {
        toolbar: Settings,
    },
};

FormNodeSwitch.Icon = () => {
    return (<span>FormNodeSwitch</span>);
}